import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Box,
	Typography,
} from '@mui/material'

import { FAQCategories, FAQCategoryDetails } from '../constants/FAQ'
import { styles } from './SupportAccordion.styles'
import SupportSubAccordion from './SupportSubAccordion'

export interface SupportAccordionProps {
	activeFAQDropdown: number
	category: FAQCategories
	dropdownId: number
	setActiveFAQDropdown: (id: number) => void
}

export const SupportAccordion = ({
	activeFAQDropdown,
	category,
	dropdownId,
	setActiveFAQDropdown,
}: SupportAccordionProps) => {
	const handleClick = () => {
		if (activeFAQDropdown === dropdownId) {
			setActiveFAQDropdown(-1)
		} else {
			setActiveFAQDropdown(dropdownId)
		}
	}

	return (
		<Box
			data-testid={`support-accordion__${category.toLowerCase().replace(/\s+/g, '-')}`}
		>
			<Accordion
				elevation={0}
				sx={styles.accordion}
				expanded={activeFAQDropdown === dropdownId}
				data-testid={`support-accordion__${category.toLowerCase().replace(/\s+/g, '-')}-accordion`}
			>
				<AccordionSummary
					sx={styles.accordionSummary}
					expandIcon={<ExpandMoreIcon sx={styles.expandIcon} />}
					onClick={handleClick}
					data-testid={`support-accordion__${category.toLowerCase().replace(/\s+/g, '-')}-summary`}
				>
					<Typography
						sx={styles.categoryTypography}
						data-testid={`support-accordion__${category.toLowerCase().replace(/\s+/g, '-')}-title`}
					>
						{category}
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<SupportSubAccordion
						categoryDetails={FAQCategoryDetails[category]}
						parentOpen={activeFAQDropdown === dropdownId}
					/>
				</AccordionDetails>
			</Accordion>
		</Box>
	)
}

export default SupportAccordion
